import { useRecoilState, useResetRecoilState } from 'recoil';
import { networkScanState } from 'states/atoms';
import { formatSpeed } from 'utils/NetworkScan';
import { usePageState } from './usePageState';
import { useEffect } from 'react';
import { SpeedTestStatus } from 'types/NetworkScan/SpeedTestStatus';

export const useNetworkScan = () => {
  const { page, setNetworkState } = usePageState();
  const { downloadSpeed, uploadSpeed } = page.networkState;

  const [networkScan, setNetworkScan] = useRecoilState(networkScanState);
  const resetNetworkScan = useResetRecoilState(networkScanState);
  const { scanState } = networkScan;

  useEffect(() => {
    console.log('scan state: ', scanState);
  }, [scanState]);

  return {
    scanState: scanState,
    downloadSpeed,
    uploadSpeed,
    downloadSpeedLabel: downloadSpeed && formatSpeed(downloadSpeed).toString(),
    uploadSpeedLabel: uploadSpeed && formatSpeed(uploadSpeed).toString(),
    startScan: async () => {
      setTimeout(() => {
        setNetworkScan((netScan) => ({
          ...netScan,
          scanState: SpeedTestStatus.completed,
        }));
        setNetworkState({
          downloadSpeed: '99',
          uploadSpeed: '99',
        });
      }, 3000);
    },
    cancelScan: () => {
      resetNetworkScan();
      setNetworkState({
        downloadSpeed: '',
        uploadSpeed: '',
      });
    },
  };
};
